import { downloadInvoicePdf as downloadInvoicePdfAction } from '../redux/ducks/invoices';

export const downloadBlob = (data, filename, mime = 'text/csv') => {
    const blob = new Blob([data], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

export const escapeCsv = (v) => {
    if (v === null || v === undefined) return '';
    const s = String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const toCsv = (rows, columns) => {
    const head = columns.map(c => escapeCsv(c.header)).join(',');
    const body = rows.map(r => columns.map(c => escapeCsv(c.get(r))).join(',')).join('\n');
    return head + '\n' + body;
};

export const downloadInvoicePdf = (dispatch, invoiceId, invoiceNumber) =>
    new Promise((resolve, reject) => {
        dispatch(downloadInvoicePdfAction(invoiceId, (resp) => {
            if (!resp?.ok) {
                reject(new Error(resp?.message || 'Failed to download invoice PDF'));
                return;
            }
            downloadBlob(resp.data, `Invoice-${invoiceNumber}.pdf`, 'application/pdf');
            resolve();
        }));
    });
